import { render, staticRenderFns } from "./ReportSettings.vue?vue&type=template&id=4d8a5e4e"
import script from "./ReportSettings.vue?vue&type=script&lang=js"
export * from "./ReportSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports